var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"integrationsPage"}},[_c('h4',{staticClass:"group-title"},[_vm._v("eCommerce Platforms")]),_c('p',{staticClass:"description"},[_vm._v("Manage connections with eCommerce platforms.")]),_c('BigCommerceApp'),_c('WordpressPlugin')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }